<template>
  <!--  预约专家介绍-->
  <div class="experts" >
    <van-sticky>
      <div class="experts_top">
        <div class="experts_info" >
          <van-image
              round
              class="experts_picture"
              :src="subscribeInfo.headImg"
          />
          <div class="experts_name">
            <div style="display: flex;text-align:center;align-items: center;">
              <h3 style="margin: 0 10px 0 0;">{{ subscribeInfo.name }}</h3>
              <span>{{ subscribeInfo.title }}</span>
            </div>
            <span style="font-size: 14px">
            {{ subscribeInfo.hospital }}
          </span>
          </div>
        </div>
        <div class="experts_tag">
        <span class="tabs_list" v-if="subscribeInfo.tags">
          {{ subscribeInfo.tags }}
        </span>
        </div>
      </div>
    </van-sticky>

    <div class="experts_tabs" >
      <van-tabs v-model="type" color="#47A5E5" title-active-color="#47A5E5" scrollspy sticky offset-top="128px">
        <van-tab title="介绍" name='介绍' >
          <div style="padding-left: 2%;padding-right: 2%"><p style="white-space: pre-wrap;">{{subscribeInfo.intro}}</p></div>

        </van-tab>
        <van-tab title="推荐" name='推荐' >
          <div >
            <h3 style="padding-left: 2%">推荐</h3>
            <videoView :videoList="subscribeInfo.recomMend" />
          </div>

        </van-tab>
      </van-tabs>


    </div>
    <openAPP/>
  </div>
</template>

<script>

import {getSubscribeInfo} from "@/service/subscribeShare_api";
import {Notify} from "vant";

export default {
  name: "subscribeExperts",
  data() {
    return {
      activeName:'',
      subscribeInfo:{},
      fullscreenLoading: false,
      list:[],
      type:'介绍',
    }
  },
  components:{
    openAPP:()=>import('../../components/share_foot'),
    videoView:()=>import('../../components/videoRecommended')
  },
  mounted() {
    this.getSubscribe(this.$route.query.id)
  },
  methods:{
    async getSubscribe(id){
      this.fullscreenLoading =true
      const info =await getSubscribeInfo(id)
      if (info.code===0){
        this.subscribeInfo = info.data
      }else {
        Notify({ type: 'danger', message: '连接失败'+info.message });
      }
      this.fullscreenLoading = false
    }
  }

}
</script>

<style lang="scss" scoped>
.experts{
  height: 100%;
  .experts_top{
    min-height: 110px;
    min-width: 110px;
    background: linear-gradient(187deg, #036CB0, #2796DD);
    color: white;
    padding: 10px 10px 10px 20px;
    .experts_info{
      display: flex;
      .experts_picture{
        width: 60px;
        height: 60px;
        border-radius: 60px;
        background-color: white;
      }
      .experts_name{
        padding: 10px;
      }
    }
    .experts_tag{
      margin-top: 10px;
      text-align:center;
      display:flex;
      .tabs_list{
        height: 20px;
        padding: 2px;
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        line-height:20px
      }
    }
  }
  .experts_tabs{
    ::v-deep.van-tabs__wrap{
      border-bottom: 2px solid #DDDDDD;
    }
    ::v-deep.van-tabs__content{
      margin: 10px auto 0;
      width: 95%;
    }
  }

}
</style>
